//Libraries
import axios from "axios";

// Client-safe auth helpers. No @auth0/nextjs-auth0 import here so this module is
// safe to ship in the browser bundle.

// Per-request Bearer header. Used by SSR-invoked services that receive a token.
export const awAuthHeader = (token) => (token ? { Authorization: `Bearer ${token}` } : {});

// --- Login URL ---
// The API audience differs per environment (QA / PROD), so it comes from
// NEXT_PUBLIC_AW_AUTH_AUDIENCE (exposed as AW_AUTH_AUDIENCE in next.config.js).
// Server-side token requests use AW_TOKEN_OPTS in services/serverAuth.js.
export const AW_AUDIENCE = process.env.AW_AUTH_AUDIENCE;

export const AW_LOGIN_URL = `/api/auth/login?audience=${encodeURIComponent(AW_AUDIENCE)}&scope=${encodeURIComponent("openid profile email")}`;

// --- Client token: cached in memory until exp - 60s ---
let _cached = null; // { token, exp }

const _decodeExp = (jwt) => {
  try {
    return JSON.parse(atob(jwt.split(".")[1])).exp * 1000;
  } catch (e) {
    return 0;
  }
};

export const getClientToken = async () => {
  if (_cached && Date.now() < _cached.exp - 60000) return _cached.token;

  try {
    const res = await axios.get("/api/token");
    const token = res && res.data && res.data.accessToken ? res.data.accessToken : null;
    _cached = token ? { token, exp: _decodeExp(token) } : null;

    return token;
  } catch (e) {
    return null;
  }
};

// --- Interceptor: in the browser, attach Bearer to AW_API_HOST requests ---
let _installed = false;

export const installClientAuthInterceptor = () => {
  if (_installed || typeof window === "undefined") return;
  _installed = true;

  axios.interceptors.request.use(async (config) => {
    const url = config.url || "";

    if (url.startsWith(process.env.AW_API_HOST) && !(config.headers && config.headers.Authorization)) {
      const token = await getClientToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });
};

installClientAuthInterceptor(); // idempotent, no-op on the server
